import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "label", "to", "className"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { Link } from 'gatsby';
import { getInternalLinkProps } from './InternalLink.utils';
import { withEvent } from '../../modules/analytics/components/Event';
import { ChildrenPropType } from '../../services/proptypes';
var defaultProps = {
  label: '',
  className: '',
  children: null
};
function InternalLink(_ref) {
  var children = _ref.children,
    label = _ref.label,
    to = _ref.to,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var containerProps = getInternalLinkProps(_objectSpread({
    to: to,
    className: className,
    label: label
  }, rest));
  return /*#__PURE__*/React.createElement(Link, containerProps, children || label);
}
InternalLink.defaultProps = defaultProps;
export default withEvent('click')(InternalLink);